module.exports = app_supply_payments_offer_selection;